// Template Generated by DataExtraction.py at 1714175047
        
import IllustrationDisclosureSIEn1 from "../../Forms/Illustration Disclosure/IllustrationDisclosure_SIEn1.png";
import IllustrationDisclosureSIEn1Labels from "../../Labels/Illustration Disclosure/IllustrationDisclosure_SIEn1.json";
import IllustrationDisclosureSIFr1 from "../../Forms/Illustration Disclosure/IllustrationDisclosure_SIFr1.png";
import IllustrationDisclosureSIFr1Labels from "../../Labels/Illustration Disclosure/IllustrationDisclosure_SIFr1.json";
import {
    defaultFontSize,
    drawTextOnLabel,
    fillCheckboxAtLabel,
    standardFormAlias,
    standardFormCompression,
    isLanguageEnglish,
    standardFormFormat,
    standardFormHeight,
    standardFormWidth,
    standardFormX,
    standardFormY, signatureTab, signatureLabel
} from "../../PDFGenerationUtils";
import moment from "moment/moment";
import {t} from "i18next";
import {POSSIBLE_SIGNERS} from "../../../Utils/PlanUtils";

/*
 * @param doc {jsPDF}
 */
const generate = (doc, data, quote, authStatus, i18n) => {

    const isFrench = !isLanguageEnglish(i18n);
    const labels = isFrench ? IllustrationDisclosureSIFr1Labels : IllustrationDisclosureSIEn1Labels;
    const formImage = isFrench ? IllustrationDisclosureSIFr1 : IllustrationDisclosureSIEn1;

    function fillCheckbox(value, label) {
        fillCheckboxAtLabel(doc, value, label, labels);
    }
    
    function drawText(value, label){
        drawTextOnLabel(doc, value, label, labels);
    }

    // add image
    doc.addImage(formImage, standardFormFormat, labels["image"]["x"], labels["image"]["y"], labels["image"]["width"], labels["image"]["height"], null, standardFormCompression);

    /* define state variables here ie:
     * const subscriber = data.subscriber;
     * const jointSubscriber = data.jointSubscriber;
     * const beneficiary = data.beneficiary;
    */

    const common = data.common;

    const nowDate = moment(new Date()).format("MMMM D, YYYY");


    const formattedDate = new Intl.DateTimeFormat(i18n.language, {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      }).format(new Date());
      
      drawText(formattedDate, "drdate");
      drawText(formattedDate, "s1date");
      drawText(t("2 of 2"), "lblPageNumber");
    if (common.subscriber2Include){
        drawText(nowDate, "s2date");
    }
}

//Returns the signature definitions for the document
// This includes who needs to sign and where
const signatureDefinitions = (state, documentId, pageNumber, i18n) => {
    const isFrench = !isLanguageEnglish(i18n);
    const labels = isFrench ? IllustrationDisclosureSIFr1Labels : IllustrationDisclosureSIEn1Labels;
    const DRRecipientId = POSSIBLE_SIGNERS['Dealing Representative'];
    const subscriberRecipientId = POSSIBLE_SIGNERS['Subscriber'];
    const jointSubscriberRecipientId = POSSIBLE_SIGNERS['Joint Subscriber'];
    let signers = [];
    let signHereTabs = [];

    signers.push({
        [DRRecipientId]: [signatureTab(DRRecipientId, documentId, pageNumber, signatureLabel('drsignatureView', labels))],
    });

    signers.push({
        [subscriberRecipientId]: [signatureTab(DRRecipientId, documentId, pageNumber, signatureLabel('s1signatureView', labels))],
    });

    if (state.common.subscriber2Include) {
        signers.push({
            [jointSubscriberRecipientId]: [signatureTab(DRRecipientId, documentId, pageNumber, signatureLabel('s2signatureView', labels))],
        });
    }

    return signers;
}

export default {
    generate,
    signatureDefinitions
}
    